


















































































































import Vue from "vue"
import ColReqAddressForm from "@/components/new-collection-request/ColReqAddressForm.vue"
import {ColReqAddress} from "@/model/entity/collection-request/col-req-address"
import PickupDataForm, {IPickupDataForm} from "@/components/new-collection-request/PickupDataForm.vue"
import {CollectionRequest} from "@/model/entity/collection-request/collection-request"
import {PickupData} from "@/model/entity/collection-request/pickup-data"
import ColReqProductGroup, { IColReqProductGroup } from "@/components/new-collection-request/ColReqProductGroup.vue"
import {collectionRequestService} from "@/model/service/collection-request/collection-request-service"
import {classToPlain, plainToClass} from "class-transformer"
import {DpdProduct} from "@/model/new-parcel-model/dpd-product/dpd-product"
import {CreateParcelModel} from "@/model/new-parcel-model/create-parcel-model"
import {DpdProductVariant} from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import ParcelShopGroup, { IParcelShopGroup } from "@/components/new-parcel-groups/ParcelShopGroup.vue"
import {Country} from "@/model/entity/country/country"
import {ShipmentParcelShop} from "@/model/entity/shipment/shipment-parcel-shop"
import {IProductGroup} from "@/components/new-parcel-groups/ProductGroup.vue"
import {IReceiverGroup} from "@/components/new-parcel-groups/ReceiverGroup.vue"
import {IAdditionalOptionsGroup} from "@/components/new-parcel-groups/AdditionalOptionsGroup.vue"
import {ICodGroup} from "@/components/new-parcel-groups/CodGroup.vue"
import {ParcelModelHelper} from "@/model/new-parcel-model/parcel-model-helper"
import {pickupDiffService} from "@/model/service/pickupdiff/pickupdiff-service"

interface SimpleCountry {
  name: string
  code: string
  currency: string
  i18nKey: string
}

export default Vue.extend({
  components: {
    ColReqAddressForm,
    PickupDataForm,
    ColReqProductGroup,
    ParcelShopGroup
  },
  data() {
    return {
      dpdProducts: [],
      dpdVariants: [],
      createParcelModel: null,
      parcelNumber: 1,
      productValidated: true,
      hasProductVariant: true,
      country: null,
      parcelShopValidated: true,
      collectionRequestService: collectionRequestService,
      internalColReq: new CollectionRequest(new ColReqAddress(), new ColReqAddress(), new PickupData(), null),
      readOnlyParcelWeight: "0",
      resetAllFields: 0,
      pickupAddressValid: false,
      deliveryAddressValid: false,
      pickupDataValid: false,
      carorderService: pickupDiffService,
      displayMsg: false

    }
  },
  props: {
    externalColReq: {
      type: Object as () => CollectionRequest
    },
    readonly: {
      type: Boolean,
      default: false
    },
    product: {
      type: DpdProductVariant
    }
  },
  methods: {
     async save() {
      const vm = this
      vm.collectionRequest.pickupData.parcelWeight = vm.collectionRequest.pickupData.parcelWeight * 1000
      if ((vm.collectionRequest.pickupAddress.country.isoCodeAlpha2 === "DE" ||
        vm.collectionRequest.deliveryAddress.country.isoCodeAlpha2 === "DE") &&
        vm.collectionRequest.pickupData.parcelWeight === 0) {
        this.$message({
          message: this.$t("collection_request.validation.pickup_data.weight").toString(),
          type: "error",
          duration: 5000
        })
        return
      }
      let newRequestResponse
      let pickupResponse
      let deliveryResponse
      const internalColReq = vm.internalColReq
      vm.startLoad()
      await vm.$http
        .post("/collection_request/new2", classToPlain(vm.getNewCollectionRequest()))
        .then(response => {
          vm.endLoad()
          newRequestResponse = response
          if (newRequestResponse.data.status !== 400) {
              vm.initiateCreateParcelModel()
          }
        })
        .catch(error => {
          vm.$error(error.message)
          vm.endLoad()
        })
      await vm.collectionRequestService.checkPickupZipCodeCountry(internalColReq).then(response => {
        pickupResponse = response
        })
        .catch(error => {
          vm.$error(error.response.data.message)
          vm.endLoad()
      })
      await vm.collectionRequestService.checkDeliveryZipCodeCountry(internalColReq).then(response => {
        deliveryResponse = response
        })
        .catch(error => {
          vm.$error(error.response.data.message)
          vm.endLoad()
      })
      if (newRequestResponse.data.status === 400) {
        vm.$error(vm.$t(newRequestResponse.data.message))
      } else {
        if (pickupResponse.data && deliveryResponse.data) {
          vm.$message({
            message: vm.$t("collection_request.save_success").toString(),
              type: "success"
            })
          } else {
            vm.$confirm(vm.$t("undeliverable_zipcode.warning").toString(), {
            confirmButtonText: "OK",
            type: "warning",
            center: true,
            showCancelButton: false
          })
          }
      }


    },
    getNewCollectionRequest(): any {
      const vm = this
      vm.internalColReq.serviceCode = this.createParcelModel.dpdProductVariant.serviceCode
      if (this.createParcelModel.dpdProductVariant.parcelShop.extensionEnabled === true) {
        const parcelShopGroup = this.$refs.parcelShopGroup as IParcelShopGroup
        this.internalColReq.shipmentParcelShop = parcelShopGroup.getParcelShop()
      }
      const pickupDataForm = vm.$refs.colReqPickupDataForm as IPickupDataForm

      return {
          collectionRequest: vm.internalColReq,
          numberOfParcels: vm.parcelNumber,
          parcelWeight: pickupDataForm.parcelWeight,
          parcelWeightArray: pickupDataForm.parcelWeightArray,
          sameWeight: pickupDataForm.sameWeight
      }
    },
    initializeColReq() {
      this.internalColReq = new CollectionRequest(new ColReqAddress(), new ColReqAddress(), new PickupData(), null)
      this.internalColReq.deliveryAddress!.name = this.$store.state.authenticatedEmployee.office.officeName
      this.internalColReq.deliveryAddress!.country = this.$store.state.authenticatedEmployee.office.country
      this.internalColReq.deliveryAddress!.postalCode = this.$store.state.authenticatedEmployee.office.officeZip
      this.internalColReq.deliveryAddress!.city = this.$store.state.authenticatedEmployee.office.officeCity
      this.internalColReq.deliveryAddress!.street = this.$store.state.authenticatedEmployee.office.officeStreet
      this.internalColReq.deliveryAddress!.houseNumber
      = this.$store.state.authenticatedEmployee.office.officeHouseNumber
      this.internalColReq.deliveryAddress!.name2 = this.$store.state.authenticatedEmployee.office.officeContactPerson
      this.internalColReq.deliveryAddress!.phone = this.$store.state.authenticatedEmployee.office.officeTel
      this.internalColReq.deliveryAddress!.email = this.$store.state.authenticatedEmployee.office.officeEmail
    },
    initializeFromExistingColReq() {
      const vm = this
      const codCountries = vm.$store.getters.codCountries
      const roadExportCountries = vm.$store.getters.roadExportCountries
      const domesticCountryIso = vm.$store.getters.domesticCountryIso
      vm.readOnlyParcelWeight = (this.externalColReq.pickupData.parcelWeight / 1000).toString()

      vm.createParcelModel = new CreateParcelModel(
        [vm.product],
        {title: vm.product.productType, type: vm.product.productType},
        domesticCountryIso,
        this.externalColReq.pickupAddress.country.isoCodeAlpha2,
        codCountries,
        roadExportCountries
      )
      vm.hasProductVariant = true
      vm.country = this.externalColReq.pickupAddress.country

      vm.$nextTick(() => {
        const colReqProductGroup = vm.$refs.colReqProductGroup as IColReqProductGroup
        const parcelShopGroup = vm.$refs.parcelShopGroup as IParcelShopGroup

        const hasParcelShop = exists(this.externalColReq.shipmentParcelShop) &&
          exists(this.externalColReq.shipmentParcelShop.addressCountry)
        vm.createParcelModel!.createParcelModelExtensions.parcelShop.value = hasParcelShop

        if (hasParcelShop) {
          parcelShopGroup.setParcelShopFromShipment(this.externalColReq.shipmentParcelShop!)
        }

      })
    },
    async initiateCreateParcelModel() {
        const vm = this
        this.scrollToTop()

        const pickupDataForm = vm.$refs.colReqPickupDataForm as IPickupDataForm
        if (exists(pickupDataForm)) {
            this.resetForm()
        }

        vm.initializeColReq()
        vm.parcelNumber = 1
        const domesticCountryCode = vm.$store.getters.domesticCountryIso
        const codCountries = vm.$store.getters.codCountries
        const roadExportCountries = vm.$store.getters.roadExportCountries
        const parcelModelHelper = new ParcelModelHelper(vm.dpdVariants)
        const resolvedProductVariant = parcelModelHelper.resolveProductVariant("101")
        let dpdProduct = null
        await this.$http.get("/product/all_products").then(res => {
          vm.dpdProducts = res.data.filter((element) => {
            let isValid = false
            vm.dpdVariants.forEach(el => {
              if (element.type === el.productType) {
                isValid = true
              }
            })
            return isValid
            })
          dpdProduct = res.data.find((el) => {
            if (el.type === resolvedProductVariant.dpdProductVariant.productType) {
              return el
            }
          })
        })

        vm.createParcelModel = new CreateParcelModel(vm.dpdVariants, dpdProduct, domesticCountryCode,
          domesticCountryCode, codCountries,
          roadExportCountries)

        const extensions = vm.createParcelModel.createParcelModelExtensions
        extensions.parcelShop.value = resolvedProductVariant.dpdProductVariant!.parcelShop
    },
    prepareNewColReq() {
      const vm = this
      this.$http.get(`/product/active_collection_request_products/${this.$store.state.authenticatedEmployee.office.country.id}`).then(res => {
          vm.dpdVariants = plainToClass(DpdProductVariant, res.data)
          vm.initiateCreateParcelModel()
      })
    },
    // re-renders the form by increasing the key in the form by 1
    resetForm() {
      this.resetAllFields++
    },
    scrollToTop() {
        (this.$refs.newCrPanelContainer as Vue).$el.scrollTop = 0
    }
  },
  computed: {
    validationsPassed(): boolean {
      return (
        this.hasProductVariant &&
        this.productValidated &&
        this.parcelShopValidated &&
        this.pickupAddressValid &&
        this.deliveryAddressValid &&
        this.pickupDataValid
      )
    },
    collectionRequest(): CollectionRequest {
      return this.readonly ? this.externalColReq : this.internalColReq
    }
  },
  watch: {
    externalColReq: {
      handler() {
        this.initializeFromExistingColReq()
      }
    },
    "createParcelModel.createParcelModelExtensions.parcelShop.value": {
      deep: true,
      handler(newVal: boolean) {
        if (newVal) {
          const parcelShopGroup = this.$refs.parcelShopGroup as IParcelShopGroup
          parcelShopGroup.focusAutocomplete()
          parcelShopGroup.emitValidation()
        } else {
          this.parcelShopValidated = true
        }
      }
    },
    "collectionRequest.deliveryAddress": {
      deep: true,
      handler(newVal: ColReqAddress) {
        if (newVal.country.id) {
          this.$http.get(`/product/active_collection_request_products/${newVal.country.id}`).then(res => {
            this.dpdVariants = plainToClass(DpdProductVariant, res.data)
          })
        }
      }
    },
    country: {
      handler(country: Country) {
        const vm = this

        if (exists(vm.createParcelModel)) {
          vm.createParcelModel!.country = country.isoCodeAlpha2
          if (!vm.createParcelModel!.hasAvailableDpdProductVariants) {
            const availableDpdProduct = vm.dpdVariants!.find(
              dpdProduct =>
                dpdProduct.name !== vm.createParcelModel!.dpdProduct!.name &&
                vm.createParcelModel!.checkIfProductHasVariants(dpdProduct)
            )
            vm.hasProductVariant = exists(availableDpdProduct)
            if (vm.hasProductVariant) {
              vm.createParcelModel!.dpdProduct = availableDpdProduct!
            }
          } else {
            vm.hasProductVariant = true
          }
        }
      }
    }
  },
  created() {
    if (this.readonly) {
      this.initializeFromExistingColReq()
    } else {
      this.prepareNewColReq()
    }
  }
})
